<script>
import { DateTime } from 'luxon'
import { formatPhoneNumber } from '@utils/phone-format'

export default {
  props: {
    figment: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {}
  },
  methods: {
    format: formatPhoneNumber,
    formatDate(date) {
      return DateTime.fromISO(date).toFormat('MMMM dd, yyyy')
    },
    showDrawer() {
      this.$emit('showDrawer', true)
    },
    onClose() {
      this.$emit('showDrawer', false)
    },
    doCopy(text) {
      this.$copyText(text).then(
        () => {
          this.$notification.success({
            message: `Field Copied!`,
            duration: 2,
          })
        },
        () => {
          this.$notification.error({
            message: `Failed to Copy`,
            duration: 2,
          })
        }
      )
    },
  },
}
</script>

<template>
  <a-drawer
    title="Figment Details"
    placement="left"
    :closable="false"
    :visible="visible"
    width="450"
    :body-style="{ overflow: 'scroll' }"
    @close="onClose"
  >
    <div v-if="figment.meta">
      <a-descriptions
        v-if="figment.meta"
        title="Bio"
        bordered
        :column="{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }"
      >
        <a-descriptions-item label="First Name">
          {{ figment.meta.bio.firstName }}
          <a-button
            size="small"
            shape="circle"
            @click="doCopy(figment.meta.bio.firstName)"
          >
            <a-icon type="copy" />
          </a-button>
        </a-descriptions-item>

        <a-descriptions-item label="Last Name">
          {{ figment.meta.bio.lastName }}
          <a-button
            size="small"
            shape="circle"
            @click="doCopy(figment.meta.bio.lastName)"
          >
            <a-icon type="copy" />
          </a-button>
        </a-descriptions-item>

        <a-descriptions-item label="Current Location">
          {{ figment.meta.bio.currentLocation }}
          <a-button
            size="small"
            shape="circle"
            @click="doCopy(figment.meta.bio.currentLocation)"
          >
            <a-icon type="copy" />
          </a-button>
        </a-descriptions-item>

        <a-descriptions-item label="Birthplace">
          {{ figment.meta.bio.birthplace }}
          <a-button
            size="small"
            shape="circle"
            @click="doCopy(figment.meta.bio.birthplace)"
          >
            <a-icon type="copy" />
          </a-button>
        </a-descriptions-item>

        <a-descriptions-item label="DOB">
          {{ formatDate(figment.meta.bio.dob) }}
          <a-button
            size="small"
            shape="circle"
            @click="doCopy(figment.meta.bio.dob)"
          >
            <a-icon type="copy" />
          </a-button>
        </a-descriptions-item>

        <a-descriptions-item label="Email">
          {{ figment.meta.email.username }}
          <a-button
            size="small"
            shape="circle"
            @click="doCopy(figment.meta.email.username)"
          >
            <a-icon type="copy" />
          </a-button>
          <br /><br />
          <a-input-password
            placeholder="input password"
            :value="figment.meta.email.password"
          />
        </a-descriptions-item>

        <a-descriptions-item label="Status">
          <a-badge
            :status="figment.meta.bio.active ? 'success' : 'warning'"
            :text="figment.meta.bio.active ? 'Active' : 'Inactive'"
          />
        </a-descriptions-item>
      </a-descriptions>
      <br />

      <a-descriptions
        v-if="figment.meta.accounts && figment.meta.accounts.length"
        title="Accounts"
        bordered
        :column="{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }"
      >
        <a-descriptions-item
          v-for="(a, i) in figment.meta.accounts"
          :key="i"
          :label="a.platform"
        >
          {{ a.platform_username }}
          <a-button
            size="small"
            shape="circle"
            @click="doCopy(a.platform_username)"
          >
            <a-icon type="copy" />
          </a-button>
          <br /><br />
          <a-input-password
            placeholder="input password"
            :value="a.platform_password"
          />
        </a-descriptions-item>
      </a-descriptions>
      <br />

      <a-descriptions
        v-if="figment.meta.sims"
        title="SIM"
        bordered
        :column="{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }"
      >
        <a-descriptions-item label="MTN#">
          {{ format(figment.meta.sims.pk.replace('SIM#', '')) }}
          <a-button
            size="small"
            shape="circle"
            @click="doCopy(format(figment.meta.sims.pk.replace('SIM#', '')))"
          >
            <a-icon type="copy" />
          </a-button>
        </a-descriptions-item>

        <a-descriptions-item label="Hardware Id">
          {{ figment.meta.sims.hardwareId }}
          <a-button
            size="small"
            shape="circle"
            @click="doCopy(figment.meta.sims.hardwareId)"
          >
            <a-icon type="copy" />
          </a-button>
        </a-descriptions-item>
      </a-descriptions>
    </div>
  </a-drawer>
</template>

<style scoped>
.highlight {
  padding: 0;
  background-color: rgb(255, 192, 105);
}
</style>
